import * as React from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Breadcrumbs } from "@mui/material";
import { Typography } from "@mui/material";
import { useInstance } from "easy-redux-http-call";
import { AI_getEmployee } from "APIs/employee";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { AI_getNotification } from "APIs/notification";
const useStyle = makeStyles((theme) => ({
  hrName: {
    margin: "0px 15px 10px",
  },
  hrTabAlign: {
    borderBottom: 1,
    borderColor: "divider",
  },
  hrTabComponent: {
    padding: "12px",
  },
}));

// common tab component
function CommonTab({ header, page, id, icons }) {
  let { employeeid } = useParams();

  const [value, setValue] = React.useState(
    localStorage.getItem(`${id}`) || (header[0].label ? header[0].label : header[0])
  );

  const userData = useInstance(AI_getEmployee);
  const pageName = useSelector((state) => state.menu);
  const classes = useStyle();
  React.useEffect(() => {
    // localStorage.setItem(`${id}`, value);
  }, [value]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(()=>{
    AI_getNotification.call()
  })
  React.useEffect(() => {
    if (employeeid) {
      AI_getEmployee.call({
        urlParams: {
          id: employeeid,
        },
      });
    }
  }, [employeeid]);

  React.useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === `${id}`) {
        setValue(event.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [id]);

  return (
    <TabContext value={value}>
      {userData?.data && pageName.page !== "Employees" && (
        <Breadcrumbs className={classes.hrName}>
          <Typography>{pageName.page}</Typography>
          <Typography>
            {userData.data.first_name} {userData.data.last_name}
          </Typography>
        </Breadcrumbs>
      )}
      <Box className={classes.hrTabAlign}>
        <TabList variant="scrollable" onChange={handleChange}>
          {header.map((val, index) => (
            <Tab
              key={index}
              label={
                typeof val === "object" && val.icon ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {val.icon}
                    <span style={{ marginLeft: 8 }}>{val.label}</span>
                  </div>
                ) : (
                  val
                )
              }
              value={typeof val === "object" ? val.label : val}
            />
          ))}
        </TabList>
      </Box>
      {/* rendering component */}
      {page.map((component, index) => (
        <TabPanel
          key={index}
          value={header[index].label ? header[index].label : header[index]}
          className={classes.hrTabComponent}
        >
          {component}
        </TabPanel>
      ))}
    </TabContext>
  );
}

export default CommonTab;
